var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.72 20.367l-5.363-4.5c-.423-.354-.478-.985-.123-1.408.355-.423.986-.478 1.409-.123l3.83 3.214 7.713-9.193c.355-.423.986-.478 1.41-.123.422.355.478.986.123 1.409l-9 10.724z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNzIgMjAuMzY3bC01LjM2My00LjVjLS40MjMtLjM1NC0uNDc4LS45ODUtLjEyMy0xLjQwOC4zNTUtLjQyMy45ODYtLjQ3OCAxLjQwOS0uMTIzbDMuODMgMy4yMTQgNy43MTMtOS4xOTNjLjM1NS0uNDIzLjk4Ni0uNDc4IDEuNDEtLjEyMy40MjIuMzU1LjQ3OC45ODYuMTIzIDEuNDA5bC05IDEwLjcyNHoiLz4KPC9zdmc+Cg==";
export { SvgIconCheck as ReactComponent };